import { render, staticRenderFns } from "./feishuForm.vue?vue&type=template&id=28f48005&scoped=true"
import script from "./feishuForm.vue?vue&type=script&lang=js"
export * from "./feishuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f48005",
  null
  
)

export default component.exports